import $ from 'jquery';
import ArchiveView from './archive/ArchiveView.es6';
import { Signal } from 'signals';

import GeminiScrollbar from 'gemini-scrollbar';
import _ from 'lodash';

import sidebarTMPL from './sidebar.tmpl';
import sidebarCSS from './sidebar.styl';
import scrollbarCSS from './scrollbars.styl';

export default class SideBar {

  constructor($container, archive, config) {
    this._$container = $container;

    this._config = config;
    this._archive = archive;
    this._createDOM(config.global);
    this._createArchiveView();
    this._createScrollBar();

    this.hovered = new Signal();
  }

  _createDOM(data) {
    this._$sidebar = $(sidebarTMPL(data));
    this._$sidebar.on('mouseover', () => this.hovered.dispatch());
    this._$fixedHeader = this._$sidebar.find('.fixedheader');
    this._$contents = this._$sidebar.find('.contents');
    this._$container.append(this._$sidebar);
  }

  _onScroll() {
    if (this._scrollElement.scrollTop() > 10) this._$fixedHeader.show();
    else this._$fixedHeader.hide();
  }

  _createArchiveView() {
    const archiveView = new ArchiveView(this._archive, this._config.archive);
    this._$contents.append(archiveView.DOM);
    archiveView.layout();
  }

  _createScrollBar() {
    this._scrollbar = new GeminiScrollbar({element: this._$sidebar[0]}).create();
    this._scrollElement = $(this._scrollbar.getViewElement());
    this._scrollElement.on('scroll', _.throttle(() => this._onScroll(), 30));
  }

}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/sidebar/SideBar.es6
 **/